<div *ngIf="loadingPDApp">
    <span class="app-loading">
        <svg class="spinner" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10" stroke-width="2"/>
        </svg>
    </span>
</div>
<form #pdAppForm="ngForm" (ngSubmit)="onSubmit(principalConfirmTemplate)" *ngIf="!loadingPDApp" class="page-form">
    <h2 *ngIf="state.messageAboutState">
        {{ state.messageAboutState }}
    </h2>

    <div *ngIf="state.showUserDetails" class="personal-details">
        <div class="row">
            <div class="col-12 personal-details-header-col">
                <h3 class="personal-details-header">
                    Personal Details
                </h3>
            </div>
            <div *ngIf="state.canEditUserDetails" class="col-10 personal-details-help-col">
                <p class="help-block">
                    This is what we have on file for you. Ensure it is up to date before starting your application.
                </p>
            </div>
            <div *ngIf="state.canEditUserDetails" class="col-2 personal-details-editbtn-col">
                <a [routerLink]="['/pd/account-detail']">
                    Edit
                </a>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6">

                <div class="mb-3">
                    <label class="form-label">
                        Name
                    </label>
                    <p class="form-control-static">
                        {{ pdApp.applicant.firstName }} {{ pdApp.applicant.lastName }}
                    </p>
                </div>

                <div class="mb-3">
                    <label class="form-label">
                        Address
                    </label>
                    <p class="form-control-static">
                        {{ pdApp.applicant.addressLine1 }}
                        <br *ngIf="currentUser.addressLine2"/>
                        {{ pdApp.applicant.addressLine2 }}<br/>
                        {{ pdApp.applicant.city }} {{ pdApp.applicant.postalCode }}
                    </p>
                </div>

                <div class="mb-3">
                    <label class="form-label">
                        Home Phone
                    </label>
                    <p class="form-control-static">
                        {{ pdApp.applicant.homePhone }}
                    </p>
                </div>

                <div class="mb-3">
                    <label class="form-label">
                        Preferred Email
                    </label>
                    <p *ngIf="pdApp.applicant.preferredEmail != pdApp.applicant.email" class="form-control-static">
                        <span
                            title="user is registered as {{ pdApp.applicant.email }}">{{ pdApp.applicant.preferredEmail }}
                            *</span>
                    </p>
                    <p *ngIf="pdApp.applicant.preferredEmail == pdApp.applicant.email" class="form-control-static">
                        {{ pdApp.applicant.email }}
                    </p>
                </div>
            </div>

            <div class="col-12 col-sm-6">

                <div class="mb-3">
                    <label class="form-label">
                        School
                    </label>
                    <p class="form-control-static">
                        {{ pdApp.applicant.schoolName }}
                        <br *ngIf="currentUser.schoolName && currentUser.schoolPhone"/>
                        {{ pdApp.applicant.schoolPhone }}
                    </p>
                </div>

                <div class="mb-3">
                    <label class="form-label">
                        Employment Type
                    </label>
                    <p class="form-control-static">
                        {{ pdApp.applicant.employmentType }}
                    </p>
                </div>

                <div class="mb-3">
                    <label class="form-label">
                        Grade(s)
                    </label>
                    <p class="form-control-static">
                        {{ pdApp.applicant.grades }}
                    </p>
                </div>

                <div class="mb-3">
                    <label class="form-label">
                        Subject
                    </label>
                    <p class="form-control-static">
                        {{ pdApp.applicant.subject }}
                    </p>
                </div>

                <div class="mb-3">
                    <label class="form-label">
                        Teaching Certificate Number
                    </label>
                    <p class="form-control-static">
                        {{ pdApp.applicant.teachingCertNo }}
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="event-details customPrintPageAvoid">
        <h3 class="event-details-header">
            Event Details
        </h3>
        <!--<div>
            TODO: select from list or pick new event
        </div>-->
        <div class="create-new-event-div">
            <p *ngIf="state.canEditEventDetails" class="help-block event-details-help-block">
                Please Enter Event Details
            </p>
            <div class="lined-input-group">
                <label for="eventName">
                    Event Name
                </label>
                <input #eventName="ngModel" [(ngModel)]="pdApp.event.name" [disabled]="!state.canEditEventDetails"
                       [ngClass]="{'form-control-plaintext': !state.canEditEventDetails}" class="form-control"
                       id="eventName"
                       name="eventName"
                       required
                       type="text"/>
                <div *ngIf="eventName.invalid && (eventName.dirty || eventName.touched)"
                     class="alert alert-danger">

                    <div *ngIf="eventName.errors.required">
                        Event name is required.
                    </div>
                </div>
            </div>
            <div class="lined-input-group">
                <label for="eventType">
                    Event Type
                </label>
                <select #eventType="ngModel" [(ngModel)]="pdApp.event.type" [disabled]="!state.canEditEventDetails"
                        [ngClass]="{'form-control-plaintext': !state.canEditEventDetails}"
                        class="form-select form-control"
                        id="eventType"
                        name="eventType"
                        required>
                    <option value="Conference">Conference</option>
                    <option value="Workshop">Workshop</option>
                    <option value="Non-credit Course">Non-credit Course</option>
                    <option value="Other">Other</option>
                </select>
                <div *ngIf="eventType.invalid && (eventType.dirty || eventType.touched)"
                     class="alert alert-danger">

                    <div *ngIf="eventType.errors.required">
                        Event Type is required.
                    </div>
                </div>
            </div>
            <div class="lined-input-group">
                <label for="eventDescription">
                    Event Description
                </label>
                <textarea #eventDescription="ngModel" [(ngModel)]="pdApp.event.description"
                          [disabled]="!state.canEditEventDetails"
                          [ngClass]="{'form-control-plaintext': !state.canEditEventDetails}" class="form-control"
                          id="eventDescription" name="eventDescription"
                          required
                          rows="2"></textarea>
                <div *ngIf="eventDescription.invalid && (eventDescription.dirty || eventDescription.touched)"
                     class="alert alert-danger">

                    <div *ngIf="eventDescription.errors.required">
                        Event description is required.
                    </div>
                </div>
            </div>
            <div class="lined-input-group">
                <label for="eventLocation">
                    Event Location
                </label>
                <input #eventLocation="ngModel" [(ngModel)]="pdApp.event.location"
                       [disabled]="!state.canEditEventDetails"
                       [ngClass]="{'form-control-plaintext': !state.canEditEventDetails}" class="form-control"
                       id="eventLocation" name="eventLocation"
                       required
                       type="text"/>
                <div *ngIf="eventLocation.invalid && (eventLocation.dirty || eventLocation.touched)"
                     class="alert alert-danger">

                    <div *ngIf="eventLocation.errors.required">
                        Event Location is required.
                    </div>
                </div>
            </div>
            <hr/>
            <div [hidden]="this.nonContinuousExists()" class="lined-input-group">
                <label for="startDateInput">
                    Event Start Date
                </label>
                <input #eventStartDate="ngModel"
                       #startDatePicker="bsDatepicker"
                       [(ngModel)]="pdApp.event.startDate"
                       [disabled]="!state.canEditEventDetails"
                       [hidden]="this.pdApp.event.useNonContinuousDate"
                       [ngClass]="{'form-control-plaintext': !state.canEditEventDetails}"
                       bsDatepicker
                       class="form-control"
                       id="startDateInput"
                       name="eventStartDate"
                       ngOnChanges
                       required
                       type="text">
                <div *ngIf="eventStartDate.invalid && (eventStartDate.dirty || eventStartDate.touched)"
                     class="alert alert-danger">

                    <div *ngIf="eventStartDate.errors.required">
                        Event Start Date is required.
                    </div>
                </div>
            </div>
            <div [hidden]="this.pdApp.event.useNonContinuousDate" class="lined-input-group">
                <label for="endDateInput">
                    Event End Date
                </label>
                <input #endDatePicker="bsDatepicker"
                       #eventEndDate="ngModel"
                       [(ngModel)]="pdApp.event.endDate"
                       [disabled]="!state.canEditEventDetails"
                       [ngClass]="{'form-control-plaintext': !state.canEditEventDetails}"
                       bsDatepicker
                       class="form-control"
                       id="endDateInput"
                       name="eventEndDate"
                       required
                       type="text">
                <div *ngIf="eventEndDate.invalid && (eventEndDate.dirty || eventEndDate.touched)"
                     class="alert alert-danger">

                    <div *ngIf="eventEndDate.errors.required">
                        Event End Date is required.
                    </div>
                </div>
            </div>
            <div class="lined-input-group">
                <label [hidden]="!this.pdApp.event.useNonContinuousDate || !this.nonContinuousExists()"
                       class="doNotPrint">
                    Select Dates
                </label>
                <p [hidden]="(!this.pdApp.event.useNonContinuousDate && this.nonContinuousExists())" class="help-block">
                    {{ dateHelpText }}
                </p>
                <bs-datepicker-inline (bsValueChange)="onCalendarSelect($event, acknowledgementTemplate )"
                                      [dateCustomClasses]="dateCustomClasses"
                                      [datesEnabled]="state.canEditEventDetails ? null : datesEnabled"
                                      [hidden]="!this.pdApp.event.useNonContinuousDate || !this.nonContinuousExists() || currentUser.isAuditor"
                                      class="doNotPrint"
                                      id="nonContinuousDateInput"></bs-datepicker-inline>
                <p [hidden]="!this.pdApp.event.useNonContinuousDate || !this.nonContinuousExists()">
                    Selected Dates: {{ getDates() }}
                </p>
                <div *ngIf="!this.nonContinuousExists() && this.pdApp.event.useNonContinuousDate"
                     class="alert alert-danger">
                    Old Applications can not select non-continuous dates
                </div>
            </div>
            <hr/>
            <p class="help-block additional-event-info-help-block">
                {{ conferenceInfoText }}
            </p>
            <div class="lined-input-group customPrintPageBefore">
                <label for="eventUrl">
                    Event URL
                </label>
                <input *ngIf="state.canEditEventDetails" [(ngModel)]="pdApp.event.eventUrl" class="form-control"
                       id="eventUrl" name="eventUrl"
                       type="text"/>
                <a *ngIf="!state.canEditEventDetails" class="form-control-plaintext" href="{{pdApp.event.eventUrl}}"
                   target="_blank">
                    {{ pdApp.event.eventUrl }}
                </a>
            </div>
            <div>
                Upload Conference Documents
                <!-- [(ngModel)]="pdApp.event.files" binds the event files model to the file upload component via ControlValueAccessor.
                     The control is registered with the parent ngForm (name="eventFiles") so its validator participates in
                     pdAppForm.form.valid — the submit button's [disabled] guard will block submission while a file is uploading. -->
                <eil-file-upload [(ngModel)]="pdApp.event.files" [applicationId]="pdApp.id"
                                 [disabled]="!state.canEditEventDetails" [downloadType]="'eventFile'"
                                 name="eventFiles"></eil-file-upload>
            </div>
        </div>
    </div>

    <div *ngIf="state.showExplanation" class="explanation customPrintPageAvoid">
        <h3 class="explanation-header">
            Explanation
        </h3>
        <div class="mb-3 lined-input-group">
            <p class="help-block">
                {{ pdExplanationHelpText }}
            </p>
            <textarea #explanationText="ngModel" [(ngModel)]="pdApp.explanation" [disabled]="!state.canEditExplanation"
                      [ngClass]="{'form-control-plaintext': !state.canEditExplanation}"
                      class="form-control" id="explanationText" name="explanationText"
                      required
                      rows="4"></textarea>
            <div *ngIf="explanationText.invalid && (explanationText.dirty || explanationText.touched)"
                 class="alert alert-danger">
                <div *ngIf="explanationText.errors.required">
                    Explanation is required.
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="state.showExpenseReceipts" class="receipts customPrintPageAvoid">
        <h3 class="explanation-header">
            Receipts
        </h3>
        <div>
            <eil-file-upload [(ngModel)]="pdApp.receipts" [applicationId]="pdApp.id"
                             [disabled]="!state.canUploadExpenseReceipts" [downloadType]="'receipt'"
                             name="receipts"></eil-file-upload>
        </div>
    </div>
    <div *ngIf="state.showSubNames" class="sub-names doNotPrint">
        <h3 class="explanation-header">
            Sub Name(s), please enter for each sub which date(s) they were needed.
        </h3>
        <p [hidden]="!this.pdApp.event.useNonContinuousDate || !this.nonContinuousExists()">
            Selected Dates: {{ getDates() }}
        </p>
        <div class="mb-3 lined-input-group">
            <input #subNames="ngModel" [(ngModel)]="pdApp.subNames" [disabled]="!state.canProvideSubNames"
                   [ngClass]="{'form-control-plaintext': !state.canProvideSubNames}" [required]="subNamesRequired()"
                   class="form-control" id="subNames"
                   name="subNames"
                   type="text"/>
            <div *ngIf="subNames.invalid && (subNames.dirty || subNames.touched)"
                 class="alert alert-danger">

                <div *ngIf="subNames.errors.required">
                    Substitute Names are required if any substitute time is listed below.
                </div>
            </div>
        </div>
    </div>

    <div class="expenses">
        <h3 class="expenses-header">
            {{ state.expensesAreActual ? 'Actual' : 'Anticipated' }} Expenses
        </h3>

        <div class="substitute-expenses">
            <h5 class="substitute-header">
                Substitute Expenses
            </h5>
            <p class="substitute-blurb help-block customPrintPageAvoid">
                {{ substituteHelpText }}
            </p>
            <p class="substitute-blurb help-block customPrintPageAvoid">
            <div class="days-1-to-3 customPrintPageAvoid">
                <h6>
                    Days 1, 2 &amp; 3
                </h6>
                <div class="lined-input-group">
                    <div class="row">
                        <div class="col-lg-4 col-12">
                            <label for="partialDaysUnitCalc">
                                Number of partial days
                            </label>
                        </div>
                        <div class="col-lg-8 col-12">
                            <eil-unitcalcpair #partialDaysUnitCalc
                                              (change)="updateTotal()"
                                              (focusin)="ShowSubDaysAcknowledgmentDialog(acknowledgementTemplate)"
                                              [(ngModel)]="pdApp.partialDaysCalculation"
                                              [actual]="state.expensesAreActual"
                                              [disabled]="!state.canEditExpenses"
                                              [ngModelOptions]="{standalone: true}"
                                              [unitPrefix]="'$'"
                                              name="partialDaysUnitCalc"
                            ></eil-unitcalcpair>
                        </div>
                    </div>
                </div>
                <div class="lined-input-group">
                    <div class="row">
                        <div class="col-lg-4 col-12">
                            <label for="fullDaysUnitCalc">
                                Number of full days
                            </label>
                        </div>
                        <div class="col-lg-8 col-12">
                            <eil-unitcalcpair #fullDaysUnitCalc
                                              (change)="updateTotal()"
                                              (focusin)="ShowSubDaysAcknowledgmentDialog(acknowledgementTemplate)"
                                              [(ngModel)]="pdApp.fullDaysCalculation"
                                              [actual]="state.expensesAreActual"
                                              [disabled]="!state.canEditExpenses"
                                              [ngModelOptions]="{standalone: true}"
                                              [unitPrefix]="'$'"
                                              name="fullDaysUnitCalc"
                            ></eil-unitcalcpair>
                        </div>
                    </div>
                </div>
            </div>
            <div class="days-4-and-later customPrintPageAvoid">
                <h6>
                    Days 4 and later (at grid rates)
                </h6>
                <p class="days-4-and-later-note help-block">
                    up to the maximum rate as indicated, depending upon substitute's experience
                </p>
                <div class="lined-input-group">
                    <div class="row">
                        <div class="col-lg-4 col-12">
                            <label for="gridDaysUnitCalc">
                                Number of grid days
                            </label>
                        </div>
                        <div class="col-lg-8 col-12">
                            <eil-unitcalcpair #gridDaysUnitCalc
                                              (change)="updateTotal()"
                                              (focusin)="ShowSubDaysAcknowledgmentDialog(acknowledgementTemplate)"
                                              [(ngModel)]="pdApp.gridDaysCalculation"
                                              [actual]="state.expensesAreActual"
                                              [disabled]="!state.canEditExpenses"
                                              [ngModelOptions]="{standalone: true}"
                                              [unitCostEditable]="state.gridUnitCostEditable"
                                              [unitPrefix]="'$'"
                                              name="gridDaysUnitCalc"
                            ></eil-unitcalcpair>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="registration-expenses customPrintPageAvoid">
            <h5 class="registration-expenses-header">
                Registration Expenses
            </h5>
            <div class="lined-input-group">
                <div class="row">
                    <div class="col-lg-4 col-12">
                        <label for="registrationFee">
                            Registration Fee
                        </label>
                    </div>
                    <div class="col-lg-8 col-12">
                        <div class="right-align">
                            <eil-amountpair (change)="updateTotal()"
                                            [(ngModel)]="pdApp.registrationFee" [actual]="state.expensesAreActual"
                                            [amountPrefix]="'$'"
                                            [disabled]="!state.canEditExpenses"
                                            [ngModelOptions]="{standalone: true}"
                                            [placeholder]="0"></eil-amountpair>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="travel-expenses customPrintPageAvoid">
            <h5 class="travel-expenses-header">
                Travel Expenses
            </h5>
            <div class="row">
                <div class="col-lg-3 col-12">
                    <label for="carAllowanceUnitCalc">
                        Car Allowance
                    </label>
                </div>
                <div class="col-lg-9 col-12 lined-input-group">

                    <eil-unitcalcpair #carAllowanceUnitCalc
                                      (change)="updateTotal()"
                                      (focusin)="ShowCarAllowanceDialog(acknowledgementTemplate)"
                                      [(ngModel)]="pdApp.carAllowanceCalculation" [actual]="state.expensesAreActual"
                                      [disabled]="!state.canEditExpenses"
                                      [ngModelOptions]="{standalone: true}"
                                      [unitPrefix]="'$'"
                                      name="carAllowanceUnitCalc"
                    ></eil-unitcalcpair>
                </div>
            </div>
            <div class="row customPrintPageAvoid">
                <div class="col-3">
                    <label for="flightsCost">
                        Flights
                    </label>
                </div>

                <div class="col-9 lined-input-group right-align">
                    <eil-amountpair (change)="updateTotal()"
                                    [(ngModel)]="pdApp.flightsCost" [actual]="state.expensesAreActual"
                                    [amountPrefix]="'$'"
                                    [disabled]="!state.canEditExpenses"
                                    [min]="0"
                                    [ngModelOptions]="{standalone: true}"
                                    [placeholder]="0"
                                    [step]="0.01"></eil-amountpair>
                </div>
            </div>
            <div class="row customPrintPageAvoid">
                <div class="col-3">
                    <label for="parkingCost">
                        Parking
                    </label>
                </div>
                <div class="col-9 lined-input-group right-align">
                    <eil-amountpair (change)="updateTotal()"
                                    [(ngModel)]="pdApp.parkingCost" [actual]="state.expensesAreActual"
                                    [amountPrefix]="'$'"
                                    [disabled]="!state.canEditExpenses"
                                    [min]="0"
                                    [ngModelOptions]="{standalone: true}"
                                    [placeholder]="0"
                                    [step]="0.01"></eil-amountpair>
                </div>
            </div>
            <div class="row customPrintPageAvoid">
                <div class="col-3">
                    <label for="carRentalCost">
                        Transportation
                    </label>
                </div>
                <div class="col-9 lined-input-group right-align">
                    <eil-amountpair (change)="updateTotal()"
                                    (focusin)="ShowTransportationDialog(acknowledgementTemplate )"
                                    (keyup)="updateTotal()"
                                    [(ngModel)]="pdApp.carRentalCost"
                                    [actual]="state.expensesAreActual"
                                    [amountPrefix]="'$'"
                                    [disabled]="!state.canEditExpenses"
                                    [min]="0"
                                    [ngModelOptions]="{standalone: true}"
                                    [placeholder]="0"
                                    [step]="0.01"
                    ></eil-amountpair>
                </div>
            </div>
            <div>
                <h5>
                    Other
                </h5>
                <div class="row customPrintPageAvoid">
                    <div class="col-3">
                        <label for="otherDescriptionId">
                            Description
                        </label>
                    </div>
                    <div class="col-9 ps-0 lined-input-group right-align">
                        <input #otherDescriptionBox [(ngModel)]="pdApp.otherDescription"
                               [disabled]="!state.canEditExpenses"
                               [ngClass]="{'form-control-plaintext': formIsReadonly}"
                               class="other-description"
                               id="otherDescriptionId"
                               name="otherDescription"
                               placeholder="{{ formIsReadonly ? '' : 'Description'}}" type="text"/>
                    </div>
                </div>
                <div class="row customPrintPageAvoid">
                    <div class="col-3">
                        <label for="otherCost">
                            Cost
                        </label>
                    </div>
                    <div class="col-9 lined-input-group right-align">
                        <eil-amountpair (change)="updateTotal()"
                                        (keyup)="updateTotal()" [(ngModel)]="pdApp.otherCost"
                                        [actual]="state.expensesAreActual"
                                        [amountPrefix]="'$'"
                                        [disabled]="!state.canEditExpenses"
                                        [min]="0"
                                        [ngModelOptions]="{standalone: true}"
                                        [placeholder]="0"
                                        [step]="0.01"></eil-amountpair>
                    </div>
                </div>
            </div>
        </div>

        <div class="accommodation-expenses customPrintPageAvoid">
            <h5 class="accommodation-expenses-header">
                Accommodation Expenses
            </h5>
            <div class="lined-input-group">
                <eil-unitcalcpair #accommodationUnitCalc
                                  (change)="updateTotal()"
                                  (focusin)="ShowAccommodationDialog(acknowledgementTemplate)"
                                  [(ngModel)]="pdApp.accommodationCalculation" [actual]="state.expensesAreActual"
                                  [disabled]="!state.canEditExpenses"
                                  [ngModelOptions]="{standalone: true}"
                                  [unitCostEditable]="true"
                                  [unitPrefix]="'$'"
                ></eil-unitcalcpair>
                <p class="help-block accomodations-help">Number of days x Room cost per night</p>
                <div *ngIf="accomodationUnitCostExceedsMax()"
                     class="alert alert-danger">
                    <div>
                        Accommodation cost per night has a maximum
                        of {{ maxAccommodationPricePerNight | currency:'CAD':'symbol-narrow':'1.2-2' }}
                    </div>
                </div>
                <div *ngIf="accomodationTotalExceedsMax()"
                     class="alert alert-danger">
                    <div>
                        Cannot apply for more than 25 days of accomodation
                    </div>
                </div>
            </div>
        </div>

        <div class="subsistence-expenses customPrintPageAvoid">
            <h5 class="subsistence-expenses-header">
                Subsistence Expenses
            </h5>
            <div class="lined-input-group">
                <eil-unitcalcpair #subsistenceUnitCalc
                                  (change)="updateTotal()"
                                  (focusin)="ShowSubsistenceDialog(acknowledgementTemplate)"
                                  [(ngModel)]="pdApp.subsistenceCalculation"
                                  [actual]="state.expensesAreActual"
                                  [disabled]="!state.canEditExpenses"
                                  [ngModelOptions]="{standalone: true}"
                                  [unitCostEditable]="state.canEditExpenses"
                                  [unitPrefix]="'$'"
                ></eil-unitcalcpair>
                <div *ngIf="subsistencePastMax()" class="alert alert-danger">
                    Subsistence cannot exceed the maximimum amount per day of ${{ maxSubsistencePerDay }}
                </div>
            </div>
        </div>

        <div class="expenses-total customPrintPageAvoid">
            <div *ngIf="state.expensesAreActual" [ngClass]="{'exceeded': actualExceedsAnticipated()}"
                 class="anticipated-calc">
            <span class="anticipated-text">
                Anticipated:
            </span>
                <span class="total-text">
                ${{ pdApp.anticipatedTotal }}
            </span>
            </div>
            <div [ngClass]="{'excess': anticipatedExceedsCredits()}" class="total">
                ${{ state.expensesAreActual ? pdApp.actualTotal : pdApp.anticipatedTotal }}
            </div>
            <div class="total-explanation">
                Total {{ state.expensesAreActual ? 'Actual' : 'Anticipated' }} Expenses
            </div>
            <div *ngIf="anticipatedExceedsCredits()" class="exceeds-credits">
                Exceeds available credits
            </div>
        </div>
    </div>

    <!--<div class="summary">
        <h3 class="summary-header">
            Summary
        </h3>
        <p class="help-block">
            Pending approval; values here are subject to change
        </p>
        TODO: I actually don't understand how this was meant to work; ask Stephen
    </div>-->

    <div class="doNotPrint">
        <h3>Funding Term ({{ getDateRange(term.startDate, term.endDate) }})</h3>
        <div class="allocation-bar">
            <div *ngIf="loadingFundTerm">
                <span class="app-loading">
                    <svg class="spinner" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10"
                                stroke-width="2"/>
                    </svg>
                </span>
            </div>
            <eil-app-color-bar *ngIf="!loadingFundTerm && term"
                               [ceiling]="term.startingBalance"
                               [pending]="term.totalPending"
                               [requested]="term.totalProposed"
                               [selectedIsActual]="state.expensesAreActual"
                               [selectedIsApproved]="state.ancicipatedIsApproved"
                               [selected]="term.totalSelected"
                               [showCeilingLabel]="true"
                               [showLegend]="true"
                               [showRemaining]="true"
                               [spent]="term.totalSpent">

            </eil-app-color-bar>
        </div>
    </div>
    <div class="doNotPrint">
        <h3>Credits Available</h3>
        <div class="allocation-bar">
            <eil-color-bar [available]="pdApp.applicant.unpendingBalance"
                           [ceiling]="maximumAllowedCredits"
                           [isCreditsMode]="true"
                           [pending]="pdApp.applicant.unspentBalance - pdApp.applicant.unpendingBalance"
                           [selectedIsActual]="state.expensesAreActual"
                           [selectedIsApproved]="state.ancicipatedIsApproved"
                           [selected]="term.totalSelected"
                           [showCeilingLabel]="true"
                           [showCreditAllocationExplanation]="true"
                           [showLegend]="true">

            </eil-color-bar>
        </div>
    </div>

    <div class="comments customPrintPageAvoid">
        <h3 class="comments-header">
            Additional Comments
        </h3>
        <div class="mb-3 lined-input-group">
            <textarea [(ngModel)]="pdApp.additionalComments" [disabled]="!state.canEditAdditionalComments"
                      [ngClass]="{'form-control-plaintext': !state.canEditAdditionalComments}" class="form-control"
                      id="additionalCommentText"
                      name="additionalCommentText"
                      rows="4"></textarea>
        </div>
    </div>

    <div *ngIf="!state.canApproveOrDeclineApp && pdApp.applicationApprovalComments">
        <h4>
            Application Approval Comments:
        </h4>
        <textarea [(ngModel)]="pdApp.applicationApprovalComments" [disabled]="true"
                  class="form-control form-control-plaintext"
                  id="applicationApprovalComments"
                  name="applicationApprovalComments" rows="4"></textarea>
    </div>

    <div *ngIf="state.canSubmit" class="submit-button-div">
        <div *ngIf="savingPDApp">
            <span class="app-loading">
                <svg class="spinner" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10" stroke-width="2"/>
                </svg>
            </span>
        </div>
        <button
            [disabled]="!pdAppForm.form.valid || savingPDApp || expensesTotalIsZeroOrNegative() || subDatesExceedTotalDates() || accomodationUnitCostExceedsMax() || anticipatedExceedsCredits() || subsistencePastMax() || accomodationTotalExceedsMax() || !termExists() || actualExceedsMaxSubmittable()"
            class="btn btn-primary"
            type="submit">
            {{ state.submitText }}
        </button>
        <button (click)="cancel()" *ngIf="state.canCancelApplication" class="btn btn-outline-danger" type="button">
            Cancel Application
        </button>
        <div>
            <button (click)="print()" class="btn btn-primary" type="button">Print Application</button>
        </div>
        <div
            *ngIf="pdAppForm.invalid || !pdApp.explanation || expensesTotalIsZeroOrNegative() || accomodationUnitCostExceedsMax() || subDatesExceedTotalDates() || anticipatedExceedsCredits() || subsistencePastMax() || accomodationTotalExceedsMax() || !termExists() || actualExceedsMaxSubmittable()"
            class="alert alert-danger">
            <div *ngIf="eventName.invalid && eventName.errors.required">
                Event Name is required.
            </div>
            <div *ngIf="eventDescription.invalid && eventDescription.errors.required">
                Event Description is required.
            </div>
            <div *ngIf="eventLocation.invalid && eventLocation.errors.required">
                Event Location is required.
            </div>
            <div *ngIf="eventStartDate.invalid && eventStartDate.errors.required">
                Event Start Date is required.
            </div>
            <div *ngIf="eventEndDate.invalid && eventEndDate.errors.required">
                Event End Date is required.
            </div>
            <div *ngIf="!pdApp.explanation">
                Explanation is required.
            </div>
            <div *ngIf="pdAppForm.form.get('eventFiles')?.errors?.['invalidFiles']">
                <div *ngFor="let error of pdAppForm.form.get('eventFiles')?.errors?.['invalidFiles'] | keyvalue">
                    {{ error.value }}
                </div>
            </div>
            <div *ngIf="expensesTotalIsZeroOrNegative()">
                Total expenses must be greater than $0.
            </div>
            <div *ngIf="subDatesExceedTotalDates()">
                Requested more sub dates than exist on the application
            </div>
            <div *ngIf="accomodationUnitCostExceedsMax()">
                Accommodation cost per night has a maximum
                of {{ maxAccommodationPricePerNight | currency:'CAD':'symbol-narrow':'1.2-2' }}
            </div>
            <div *ngIf="accomodationTotalExceedsMax()">
                Cannot apply for more than 25 days of accomodation
            </div>
            <div *ngIf="anticipatedExceedsCredits()">
                Cannot submit an application that requests more than you have credit for. Please adjust your application
                before submission
            </div>
            <div *ngIf="subsistencePastMax()">
                Subsistence cannot exceed the maximimum amount per day
            </div>
            <div *ngIf="!termExists()">
                No fund term exists for this event.
            </div>
            <div *ngIf="actualExceedsMaxSubmittable()">
                The amount cannot exceed the maximum claim amount
                of {{ maxExpensesSubmitable | currency:'CAD':'symbol-narrow':'1.2-2' }}
            </div>
        </div>
    </div>

    <div *ngIf="state.canApproveOrDeclineApp" class="review">
        <h3 class="review-header">
            Approve Application
        </h3>
        <div class="adjudicate-button-div">
            <div *ngIf="savingPDApp">
                <span class="app-loading">
                    <svg class="spinner" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10"
                                stroke-width="2"/>
                    </svg>
                </span>
            </div>
            <label for="applicationApprovalComments">
                Application Approval Comments
            </label>
            <textarea [(ngModel)]="pdApp.applicationApprovalComments" [disabled]="!state.canApproveOrDeclineApp"
                      [ngClass]="{'form-control-plaintext': !state.canApproveOrDeclineApp}" class="form-control"
                      id="applicationApprovalComments"
                      name="applicationApprovalComments"
                      rows="4"></textarea>
            <button (click)="approve()" [disabled]="savingPDApp" class="btn btn-primary approve doNotPrint"
                    type="button">
                Approve
            </button>
            <button (click)="decline()" [disabled]="savingPDApp" class="btn btn-outline-danger doNotPrint"
                    type="button">
                Decline
            </button>
            <button (click)="cancel()" *ngIf="state.canCancelApplication" class="btn btn-outline-danger doNotPrint"
                    type="button">
                Cancel Application
            </button>
            <div>
                <button (click)="print()" class="btn btn-primary doNotPrint" type="button">Print Application</button>
            </div>
        </div>
    </div>

    <div *ngIf="!state.canApproveOrDeclineExpenses && pdApp.expenseApprovalComments">
        <h5>
            Expense Approval Comments:
        </h5>
        <textarea [(ngModel)]="pdApp.expenseApprovalComments" [disabled]="true"
                  class="form-control form-control-plaintext"
                  id="expenseApprovalComments"
                  name="expenseApprovalComments" rows="4"></textarea>
    </div>

    <div *ngIf="state.canSubmitExpenses" class="submit-button-div">
        <div *ngIf="savingPDApp">
            <span class="app-loading">
                <svg class="spinner" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10" stroke-width="2"/>
                </svg>
            </span>
        </div>
        <div>
            <button (click)="print()" class="btn btn-primary" type="button">Print Application</button>
        </div>
        <button (click)="submitExpenses(noExpensesToSubmitTemplate, submitExpensesTemplate)"
                [disabled]="savingPDApp || expensesTotalIsZeroOrNegative() || subNamesInvalid() || subsistencePastMax() || accomodationUnitCostExceedsMax() || subDatesExceedTotalDates() || accomodationTotalExceedsMax() || pdAppForm.form.invalid"
                class="btn btn-primary"
                type="button">
            Submit Expenses
        </button>
        <div *ngIf="expensesTotalIsZeroOrNegative()" class="alert alert-danger">
            Total expenses must be greater than $0.
        </div>
        <div *ngIf="subNamesInvalid()"
             class="alert alert-danger">
            <div>
                Substitute Names are required if any substitute time is listed above.
            </div>
        </div>
        <div *ngIf="pdAppForm.form.get('receipts')?.errors?.['invalidFiles']" class="alert alert-danger">
            <div *ngFor="let error of pdAppForm.form.get('receipts')?.errors?.['invalidFiles'] | keyvalue">
                {{ error.value }}
            </div>
        </div>
        <div *ngIf="subsistencePastMax()" class="alert alert-danger">
            Subsistence cannot exceed the maximimum amount per day of ${{ maxSubsistencePerDay }}
        </div>
        <div *ngIf="accomodationUnitCostExceedsMax()" class="alert alert-danger">
            Accommodation cost per night has a maximum
            of {{ maxAccommodationPricePerNight | currency:'CAD':'symbol-narrow':'1.2-2' }}
        </div>
        <div *ngIf="accomodationTotalExceedsMax()" class="alert alert-danger">
            Cannot apply for more than 25 days of accomodation
        </div>
        <div *ngIf="subDatesExceedTotalDates()" class="alert alert-danger">
            Requested more sub dates than exist on the application
        </div>
    </div>

    <div *ngIf="state.canApproveOrDeclineExpenses" class="review doNotPrint">
        <h3 class="review-header">
            Approve Expenses
        </h3>
        <div class="adjudicate-button-div">
            <div *ngIf="savingPDApp">
                <span class="app-loading">
                    <svg class="spinner" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10"
                                stroke-width="2"/>
                    </svg>
                </span>
            </div>
            <label for="expenseApprovalComments">
                Expense Approval Comments
            </label>
            <textarea [(ngModel)]="pdApp.expenseApprovalComments" [disabled]="!state.canApproveOrDeclineExpenses"
                      [ngClass]="{'form-control-plaintext': !state.canApproveOrDeclineExpenses}" class="form-control"
                      id="expenseApprovalComments"
                      name="expenseApprovalComments"
                      rows="4"></textarea>
            <button (click)="approveExpenses()" [disabled]="savingPDApp" class="btn btn-primary approve" type="button">
                Approve
            </button>
            <button (click)="declineExpenses()" [disabled]="savingPDApp" class="btn btn-primary decline" type="button">
                Decline
            </button>
            <button (click)="cancel()" *ngIf="state.canCancelApplication" class="btn btn-outline-danger" type="button">
                Cancel Application
            </button>
            <div>
                <button (click)="print()" class="btn btn-primary" type="button">Print Application</button>
            </div>
        </div>
    </div>

    <div *ngIf="history && history.length" class="history">
        <h3>
            Change History
        </h3>
        <table class="history-table">
            <thead>
            <tr class="history-header-row">
                <th>Date</th>
                <th>Action</th>
                <th>By</th>
            </tr>
            </thead>
            <ng-template [ngForOf]="history" let-historyItem ngFor>
                <tr class="history-main-row customPrintPageAvoid">
                    <td>
                        {{ getLogDate(historyItem.actionDate) }}
                    </td>
                    <td>
                        {{ historyItem.action }}
                    </td>
                    <td title="{{historyItem.email}}">
                        {{ historyItem.name }}
                    </td>
                </tr>
                <tr *ngIf="historyItem.extraInfo" class="history-extra-info-row customPrintPageAvoid">
                    <td colspan="3">
                        {{ historyItem.extraInfo }}
                    </td>
                </tr>
                <tr *ngIf="historyItem.changes && historyItem.changes.length"
                    class="history-changes-row customPrintPageAvoid">
                    <td colspan="3">
                        Changes:
                        <table class="changes-table">
                            <thead>
                            <tr class="changes-header-row">
                                <th class="left-most-cell">Field</th>
                                <th>Original Value</th>
                                <th>New Value</th>
                            </tr>
                            </thead>
                            <tr *ngFor="let change of historyItem.changes" class="changes-main-row">
                                <td class="left-most-cell">{{ change.fieldName }}</td>
                                <td>
                                    <span [innerHTML]="change.originalValue | nl2br"></span>
                                </td>
                                <td>
                                    <span [innerHTML]="change.newValue | nl2br"></span>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </ng-template>
        </table>
    </div>


    <ng-template #acknowledgementTemplate>
        <div class="modal-header">
            <h4 class="modal-title pull-left">Please carefully review the following:</h4>
        </div>
        <div class="modal-body">
            <p [style.white-space]="'pre-line'">{{ acknowledgementModal.content?.initialState.acknowledgementMessage }}</p>
        </div>
        <div class="modal-footer">
            <div class="row modal-confirm-button-row">
                <div class="right-align">
                    <button (click)="confirmAcknowledgementModal()" class="btn btn-primary" type="button">
                        OK
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #submitExpensesTemplate>
        <div class="modal-header">
            <h4 class="modal-title pull-left">Would you like to submit?</h4>
            <button (click)="cancelSubmitExpensesModal()" aria-label="Close" class="close pull-right" type="button">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p> Please make sure you have uploaded ALL your receipts, with proof of payment in Canadian funds AND fill
                in all sections of the Actual Expenses for which you expect to be reimbursed.</p>
        </div>
        <div class="modal-footer">
            <div class="row modal-confirm-button-row">
                <div class="col-6">
                    <button (click)="cancelSubmitExpensesModal()" class="btn btn-danger-outline" type="button">
                        Cancel
                    </button>
                </div>
                <div class="col-6 right-align">
                    <button (click)="confirmExpenses()" class="btn btn-primary" type="button">
                        Submit Application
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #principalConfirmTemplate>
        <div class="modal-header">
            <h4 class="modal-title pull-left">Would you like to submit?</h4>
            <button (click)="cancelPrincipalModal()" aria-label="Close" class="close pull-right" type="button">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p>
                By submitting the application, you confirm that your absence has been approved by your principal. Please
                submit a signed copy to the office manager if substitute days are required.
            </p>
        </div>
        <div class="modal-footer">
            <div class="row modal-confirm-button-row">
                <div class="col-6">
                    <button (click)="cancelPrincipalModal()" class="btn btn-danger-outline" type="button">
                        Cancel
                    </button>
                </div>
                <div class="col-6 right-align">
                    <button (click)="confirmPrincipal()" class="btn btn-primary" type="button">
                        Submit Application
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #noExpensesToSubmitTemplate>
        <div class="modal-header">
            <h4 class="modal-title pull-left">{{ noExpenseHeader }}</h4>
            <button (click)="cancelNoExpensesModal()" aria-label="Close" class="close pull-right" type="button">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <ul *ngFor="let expense of noExpenseModalText">
                <li>{{ expense }}</li>
            </ul>
            <p>1. Ensure that you have uploaded all required receipts.</p>
            <p>2. Ensure that the expense portion of the application has been filled out.</p>
            <p>If you do not have any expenses to claim against these fields, continue with your submission.</p>
        </div>
        <div class="modal-footer">
            <div class="row modal-confirm-button-row">
                <div class="col-6">
                    <button (click)="cancelNoExpensesModal()" class="btn btn-danger-outline" type="button">
                        Cancel
                    </button>
                </div>
                <div class="col-6 right-align">
                    <button (click)="confirmNoExpenses()" class="btn btn-primary" type="button">
                        Submit Expenses
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</form>
